/*
 * HelpScreen2
 * ==========
 */
import HelpBase from '../ui/HelpBase'

export default class HelpScreen2 extends HelpBase {

  constructor (game, screens) {
    super(game);

    this.screens = screens;

    this.page = 2;

    this.params = {
      'helpWinnerText1P': [70, 170],
      'helpClickTextP': [-18, -145],
      'helpWinnerGridP': [-26, 24],
      'helpWinnerUiP': [2, 306],
      'helpWinnerText1L': [-166, 65],
      'helpClickTextL': [67, -129],
      'helpWinnerGridL': [57, 27],
      'helpWinnerUiL': [-240, -150],
      'prevL': [-50, 194],
      'nextL': [158, 194],
      'exitL': [54, 194],
      'prevP': [-104, -274],
      'nextP': [107, -274],
      'exitP': [2, -274]
    };

    this.helpClickTextP = this.addSprite('helpClickTextP', 'helpScreens', 'helpClickText.png', 'p');
    this.helpWinnerGridP = this.addSprite('helpWinnerGridP', 'helpScreens', 'helpWinnerGrid.png', 'p');

    this.helpClickTextL = this.addSprite('helpClickTextL', 'helpScreens', 'helpClickText.png', 'l');
    this.helpWinnerGridL = this.addSprite('helpWinnerGridL', 'helpScreens', 'helpWinnerGrid.png', 'l');

    this.initHelpButtons();

    this.setInputForAllButtons(false)
  }

}
